export enum SentryTags {
    Team = 'team',
}

export interface SentryProjectConfig {
    dsn: string;
    release: string;
    team: string;
}
